document.addEventListener('DOMContentLoaded', () => {
  // Get map elements
  const maps = document.querySelectorAll('.projects__map');

  function hidePopups(map) {
    const dots = map.querySelectorAll('.project-dot');
    const popups = document.querySelectorAll('.project-popup');
    const projects = map.closest('.projects');
    const popupsContainer = projects.querySelector('.projects__popups');
    map.classList.remove('has-popup-open');
    popupsContainer.classList.remove('has-popup-open');

    for (let j = 0; j < popups.length; j++) {
      const popup = popups[j];

      popup.setAttribute('aria-hidden', 'true');
    }

    for (let j = 0; j < dots.length; j++) {
      const dot = dots[j];

      dot.setAttribute('aria-pressed', 'false');
    }
  }

  function showDot(dot) {
    const map = dot.closest('.projects__map'); // Get the map this dot is within
    const projects = map.closest('.projects');
    const popupsContainer = projects.querySelector('.projects__popups');

    // Get corresponding popup
    id = dot.id;
    const popup = document.querySelector('#' + id + '-popup');

    // Check state of dot
    if (dot.getAttribute('aria-pressed') === 'true') {
      // // Hide the popup
      // map.classList.remove('has-popup-open');
      // popupsContainer.classList.remove('has-popup-open');
      // popup.setAttribute('aria-hidden', 'true');
      // dot.setAttribute('aria-pressed', 'false');
    } else {
      // Hide all popups
      hidePopups(map);

      // Show this popup
      map.classList.add('has-popup-open');
      popupsContainer.classList.add('has-popup-open');
      popup.setAttribute('aria-hidden', 'false');
      dot.setAttribute('aria-pressed', 'true');
      currentPopupIndex = parseFloat(popup.getAttribute('data-index'));
      // setTimeout(function () {
      //   popup.focus();
      // }, 300);
    }
  }

  // Clicking an office location dot
  function clickDot(event) {
    event.preventDefault();
    const dot = event.currentTarget; // Get this dot
    showDot(dot);
    // const svgRect = document
    //   .querySelector('.projects__map-svg')
    //   .getBoundingClientRect();
    // const dotRect = dot.getBoundingClientRect();
    // const popupRect = popup.getBoundingClientRect();
    // const cx = dotRect.x + dotRect.width / 2 - svgRect.left;
    // const cy = dotRect.y - dotRect.height / 2 - svgRect.top;
    // const tx = popupRect.x + popupRect.width - svgRect.left;
    // const ty = popupRect.y - svgRect.top;
    // const bx = popupRect.x + popupRect.width - svgRect.left;
    // const by = popupRect.y + popupRect.height - svgRect.top;
    // const triangle = document.getElementById('triangle');
    // const points = triangle.getAttribute('points').split(' ');
    // points[0] = cx + ',' + cy; // New coordinates for point 1
    // points[1] = bx + ',' + by; // New coordinates for point 1
    // points[2] = tx + ',' + ty; // New coordinates for point 1
    // console.log(points);
    // triangle.setAttribute('points', points.join(' '));
  }

  function hidePopup(popup) {
    popup.setAttribute('aria-hidden', 'true');
  }

  function positionPopup(dot, mapSVGBox, popup) {
    // Get transform of this dot
    const dotShape = dot.querySelector('.project-dot__circle');
    transformValue = dot.getAttribute('transform');

    // Split transform into individual values
    /* eslint-disable no-useless-escape */
    const transformNums = transformValue
      .replace('translate(', '')
      .replace(')', '');
    /* eslint-enable no-useless-escape */

    const transformSplit = transformNums.split(' ');

    const transformX = transformSplit[0];
    const transformY = transformSplit[1];

    // Convert dot's width into percentage of svg width/height
    dotHalfWidthPercent = (dotShape.getAttribute('r') / mapSVGBox.width) * 100;
    dotHalfHeightPercent =
      (dotShape.getAttribute('r') / mapSVGBox.height) * 100;

    // Convert transforms into percentages
    xPos = parseFloat(mapSVGBox.x) * -1 + parseFloat(transformX);
    yPos = parseFloat(mapSVGBox.y) * -1 + parseFloat(transformY);
    xPercent = (xPos / mapSVGBox.width) * 100;
    yPercent = (yPos / mapSVGBox.height) * 100;

    // Add half dot's width/height to percent
    xPercent = xPercent + dotHalfWidthPercent;
    yPercent = yPercent + dotHalfHeightPercent;

    // Give the popup the left/top percentage values calculated earlier
    popup.style.setProperty('--left', xPercent + '%');
    popup.style.setProperty('--top', yPercent + '%');

    // calculate width of popup and if it's too close to the left or top, make it line up with a different corner
    // get width and height of popup
    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    // get as percentages of map
    const popupWidthPercent = (popupWidth / mapSVGBox.width) * 100;
    const popupHeightPercent = (popupHeight / mapSVGBox.height) * 100;

    // Check if the popup's width is larger than its left offset
    if (popupWidthPercent > xPercent) {
      // If yes, flip it so it's within bounds
      popup.classList.add('flip-x');
    }

    // Check if the popup's height is larger than its top offset
    if (popupHeightPercent > yPercent) {
      // If yes, flip it so it's within bounds
      popup.classList.add('flip-y');
    }
  }

  function clickMap(event) {
    const map = event.currentTarget.closest('.projects__map'); // Get this map

    // Only if a project dot wasn't clicked
    if (
      !(
        event.target.classList.contains('project-dot') ||
        event.target.parentNode.classList.contains('project-dot')
      ) &&
      map.classList.contains('has-popup-open')
    ) {
      // hidePopups(map);
    }
  }

  if (maps) {
    // For each map...
    for (let i = 0; i < maps.length; i++) {
      const map = maps[i];

      // Get viewbox of svg to do maths with
      const mapSVG = map.querySelector('.projects__map-svg');
      const mapSVGBox = mapSVG.viewBox.baseVal;

      // Get all the popups
      const projects = map.closest('.projects');
      const popups = projects.querySelector('.projects__popups');
      const popupsAll = projects.querySelectorAll('.project-popup');

      // Get all project dots in this map
      const dots = map.querySelectorAll('.project-dot');

      // Dismiss all popups on map click
      mapSVG.addEventListener('click', clickMap);

      // For each dot
      for (let j = 0; j < dots.length; j++) {
        const dot = dots[j];

        // Get corresponding popup
        const id = dot.id;
        const popup = popups.querySelector('#' + id + '-popup');

        // Position the popup on the dot
        positionPopup(dot, mapSVGBox, popup);

        // Show the popup on click
        dot.addEventListener('click', clickDot);
        dot.addEventListener('click', restartCyclePopups);
      }

      popupsAll.forEach((popup) => {
        popup
          .querySelector('.project-popup__btn')
          .addEventListener('click', () => hidePopup(popup));
      });

      popups.addEventListener('click', () => {
        if (window.innerWidth < 1200) hidePopups(map);
      });

      // Automatically cycle through popups for desktop
      let popupInterval;
      let cycleSpots = window.innerWidth < 1200 ? false : true;

      function nextPopup() {
        if (cycleSpots) {
          const currentPopup = projects.querySelector(
            '.project-popup[aria-hidden="false"]',
            '.project-popup[data-start="1"]'
          );
          let currentPopupIndex = 1;
          if (currentPopup)
            currentPopupIndex = parseFloat(
              currentPopup.getAttribute('data-index')
            );
          currentPopupIndex++;
          if (currentPopupIndex > popupsAll.length) {
            currentPopupIndex = 1;
          }
          const nextPopup = map.querySelector(
            '.project-dot[data-index="' + currentPopupIndex + '"]'
          );
          if (nextPopup) showDot(nextPopup);
        }
      }

      function cyclePopups() {
        startCyclePopups();
        popupsAll.forEach((popup) => {
          popup.addEventListener('mouseenter', pauseCyclePopups);
          popup.addEventListener('mouseleave', startCyclePopups);
        });
        // map.addEventListener('mouseenter', pauseCyclePopups);
        // map.addEventListener('mouseleave', unpauseCyclePopups);
      }

      function restartCyclePopups() {
        if (cycleSpots) {
          clearInterval(popupInterval);
          setTimeout(startCyclePopups, 60000);
        }
      }

      function startCyclePopups() {
        if (cycleSpots) {
          clearInterval(popupInterval);
          popupInterval = setInterval(nextPopup, 2500);
        }
      }

      function pauseCyclePopups() {
        if (cycleSpots) {
          clearInterval(popupInterval);
        }
      }

      if (cycleSpots) {
        cyclePopups();
      } else {
        const currentPopup = projects.querySelector(
          '.project-popup[aria-hidden="false"]'
        );
        if (currentPopup) hidePopup(currentPopup);
      }

      // Signify the map is set up
      map.classList.add('ready');

      // activate the automatic cycling for desktop only
      window.addEventListener('resize', () => {
        if (window.innerWidth < 1200) {
          cycleSpots = false;
          clearInterval(popupInterval);
        } else {
          cycleSpots = true;
          cyclePopups();
        }
      });
    }
  }
});
